import { Component, OnInit, ViewEncapsulation, ElementRef, ViewChild } from '@angular/core';
import { EmployeeDemographicReportService } from './employeeDemographicReport.service';
import { AngularMultiSelect } from 'angular2-multiselect-dropdown';
import { OrderPipe } from 'ngx-order-pipe';

@Component({
    moduleId: module.id,
    templateUrl: 'employeeDemographicReport.html',
    styleUrls: ['./employeeDemographicReport.component.css']

})
export class EmployeeDemographicReportComponent implements OnInit {
    // ngAfterViewInit(): void {
    //    this.topScrollWidth = this.bottomScroll.nativeElement.scrollWidth;
    // }
    @ViewChild('dropdownRef') dropdownRef: AngularMultiSelect;
    dataLoaded: boolean;
    selectedYear: any = [];
    selectedControlGroup: string;
    selectedParentCompany: string;
    selectedProductionCompany: string;
    selectedPayrollCompany: string;
    downloadPdfInProgress: boolean = false;
    downloadExcelInProgress: boolean = false;
    order: string = 'key';
    reverse: boolean = false;
    ParentCompanies: Array<string>;
    ProductionCompanies: Array<string>;
    PayrollCompanies: Array<string>;
    Years: Array<string>;
    ControlGroups: any = [];
    headerData = [
        { name: "Controlled Group", key: "controlGroup" },
        { name: "Parent Company", key: "parentCompany" },
        { name: "Production Company", key: "productionCompany" },
        { name: "Show Name", key: "showName" },
        { name: "Payroll Source", key: "payrollCompany" },
        { name: "Employee Name", key: "firstName" },
        { name: "Union Status", key: "unionStatus" },
        { name: "Union Name", key: "unionName" },
        { name: "SSN", key: "ssn" },
        { name: "Employment Type", key: "aCAEmploymentBasis" },
        { name: "ACA Employment Status", key: "acaEmploymentStatus" },
        { name: "Last Work Date", key: "lastWorkedDate" },
        { name: "Pay Type", key: "scheduleCode" },
        { name: "Pay Rate", key: "payRate" },
        { name: "Job Description", key: "jobDescription" },
        { name: "Gender", key: "gender" },
        { name: "Date of Birth", key: "dateOfBirth" },
        { name: "Email", key: "email" },
        { name: "Address", key: "address" },
        { name: "City", key: "city" },
        { name: "State", key: "state" },
        { name: "Zip", key: "zip" },
        { name: "Country", key: "country" }
    ]
    public loading = false;
    public rows: Array<any> = [];
    public page = 1;
    public itemsPerPage = 10;
    public maxSize = 5;
    public numPages = 1;
    public length = 0;
    @ViewChild('topScroll') topScroll: ElementRef;
    @ViewChild('bottomScroll') bottomScroll: ElementRef;

    myOptionsYear: any[];

    employeeDemographicDetails: Array<any> = [];
    errorMessage: string;
    userData: any;
    paginationData: any = {};
    reportData: any = [];
    searchValue: any;
    cgDropdownSettings = {
        singleSelection: true,
        text: 'Select Controlled Group',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        classes: 'myclass custom-class single-dropdown',
        badgeShowLimit: 3
    };
    selectedCgValue: any = [];
    selectedYearValues: any = [];
    yearDropdownSettings: any = {
        singleSelection: false,
        text: 'Select Year',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        enableSearchFilter: true,
        classes: 'myclass custom-class',
        badgeShowLimit: 3
    };
    downloadpdf: any;
    downloadexcel: any;
    showfiltererror: boolean = false;
    isfilterloaded: boolean = false;
    topScrollWidth: number = 2300;
    constructor(private orderPipe: OrderPipe, private _employeeDemographicReportService: EmployeeDemographicReportService) {
        this.userData = JSON.parse(localStorage.getItem('token'));
        this.reportData = orderPipe.transform(this.headerData, 'key');
    }
    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse;
        }
        this.order = value;
    }
    ngOnInit(): void {

        if (localStorage.getItem('storedData')) {
            this.onloadData();
        }
        this.setFilterData();

        this.reset();
        this.selectedYear = [];
        this.selectedControlGroup = '';
        this.selectedParentCompany = '-1';
        this.selectedProductionCompany = '-1';
        this.selectedPayrollCompany = '-1';
    }
    reset(): void {
        this.selectedYear = '';
        this.dataLoaded = false;
        this.searchValue = '';
        this.selectedYearValues = [];
        this.showfiltererror = false;
        if (this.userData.principal.roles[0] !== 'User' || this.userData.principal.controlGroups.length > 1) {
            this.selectedControlGroup = '';
            this.selectedCgValue = [];
        }
    }
    getFilterValues(): any {

        let year = this.selectedYear;
        if (year === '-1' || !year.length) {
            year = "''";
        }

        let cg = this.selectedControlGroup;
        if (cg === 'All' || cg === '-1' || cg === undefined || !cg) {
            cg = "''";
        }
        let parentComp = this.selectedParentCompany;
        if (parentComp === '' || parentComp === '-1' || parentComp === undefined) {
            parentComp = "''";
        }
        let prodComp = this.selectedProductionCompany;
        if (prodComp === '' || prodComp === '-1' || prodComp === undefined) {
            prodComp = "''";
        }
        let payrollComp = this.selectedPayrollCompany;
        if (payrollComp === '' || payrollComp === '-1' || payrollComp === undefined) {
            payrollComp = "''";
        }
        const filterCriteria: any = {
            selectedYear: year,
            selectedControlGroup: cg,
            selectedParentCompany: parentComp,
            selectedProductionCompany: prodComp,
            selectedPayrollCompany: payrollComp
        };
        return filterCriteria;
    }

    onloadData(): void {
        this.loading = true;
        const ssnData = JSON.parse(localStorage.getItem('storedData'));
        this._employeeDemographicReportService.getSSnData(ssnData).subscribe((empDemographics:any) => {
            this.loading = false;
            this.dataLoaded = true;
            this.reportData = empDemographics.demoGraphicsReportV2Vo;
            this.paginationData = empDemographics.pagination;
        },
            error => this.errorMessage = <any>error);
    }

    downloadPdf(): void {
        this.downloadpdf = true;
        const filterCriteria = this.getFilterValues();
        this._employeeDemographicReportService.downloadPDFReport(filterCriteria).subscribe((data: any) => {
            this.downloadpdf = false;
        }, (err: any) => (this.downloadpdf = false));
    }

    downloadExcel(): void {
        this.downloadexcel = true;
        const filterCriteria = this.getFilterValues();
        this._employeeDemographicReportService.downloadExcelReport(filterCriteria).subscribe((data: any) => {
            this.downloadexcel = false
        }, (err: any) => (this.downloadexcel = false));
    }

    ngOnDestroy() {
        localStorage.removeItem('storedData')
    }

    employeeDemographicsReports(page = 1, searchKey = (this.searchValue || '')): void {
        this.showfiltererror = false;
        let filterCriteria = {
            taxYear: this.selectedYear || [],
            controlGroup: this.selectedControlGroup ? [this.selectedControlGroup] : [],
            searchKey,
            pagination: {
                pageNo: page,
                pageSize: 10
            }
        }
        if (filterCriteria.controlGroup.length === 0) {
            this.showfiltererror = true;
            this.loading = false;
            this.dataLoaded = false;
        } else {
            this.loading = true;
            this.isfilterloaded = true;
            this._employeeDemographicReportService.getEmployeeReportData(filterCriteria).subscribe((data: any) => {
                this.reportData = data.demoGraphicsReportV2Vo;
                this.paginationData = data.pagination;
                this.loading = false;
                this.isfilterloaded = false;
                this.dataLoaded = true;
                // this.topScrollWidth = this.bottomScroll.nativeElement.scrollWidth+320;
            },
                error => this.errorMessage = <any>error);
        }
    }

    Search(): void {
        this.reportData = [];
        this.paginationData = {};
        this.employeeDemographicsReports(1, this.searchValue);
    }

    onChangeTable(page: any): any {
        this.employeeDemographicsReports(page.page, this.searchValue)
    }

    searchTable(searchValue: any) {
        this.employeeDemographicsReports()
    }

    onChangeControlledGroup() {
        this.selectedControlGroup = this.selectedCgValue[0] ? this.selectedCgValue[0].itemName : '';
    }
    onChangeYear() {
        this.selectedYear = this.selectedYearValues ? this.selectedYearValues.map((item: any) => item.itemName) : [];
    }
    onItemSelect(item: any) {
        this.dropdownRef.closeDropdown()
    }
    arescrolling = 0;
    scroller(from: any, to: any) {
        if (this.arescrolling) return; // avoid potential recursion/inefficiency
        this.arescrolling = 1;
        // set the other div's scroll position equal to ours
        from.scrollLeft = to.scrollLeft;
        this.arescrolling = 0;
    }
    setFilterData() {
        this.myOptionsYear = [];
        this._employeeDemographicReportService.getReportData().subscribe(data => {
            this.myOptionsYear = data.WorkYear.map((element: any) => { return { id: element, itemName: element } });
            this.ParentCompanies = data.ParentCompany;
            this.ProductionCompanies = data.ProductionCompany;
            this.PayrollCompanies = data.PayrollCompany;
            if (this.userData.principal.roles[0] == 'User') {
                if (this.userData.principal.controlGroups.length == 1) {
                    this.cgDropdownSettings['disabled'] = true;
                    this.cgDropdownSettings = Object.assign({}, this.cgDropdownSettings);
                    this.selectedCgValue = [{ id: this.userData.principal.controlGroups[0], itemName: this.userData.principal.controlGroups[0] }]
                    this.selectedControlGroup = this.userData.principal.controlGroups[0]
                } else {
                    this.ControlGroups = this.userData.principal.controlGroups.filter((val: any) => data.ControlGroup.includes(val)).map((element: any) => { return { id: element, itemName: element } });
                }
            } else {
                this.ControlGroups = data.ControlGroup.map((element: any) => { return { id: element, itemName: element } });
            }
        },
            error => this.errorMessage = <any>error);
    }
}



// WEBPACK FOOTER //
// ./src/app/EmployeeDemographicsReport/employeeDemographicReport.component.ts